var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from "react";
import { TypographyWrapper } from "./Typography.styled";
var variantMap = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  body: "p",
  small: "p",
  mini: "p",
  button: "span",
  tile: "span",
  tile2: "span",
  tag: "span"
};

var Typography = function Typography(_a) {
  var variant = _a.variant,
      component = _a.component,
      props = __rest(_a, ["variant", "component"]);

  var renderAs = component ? component : variant ? variantMap[variant] : "p";
  return React.createElement(TypographyWrapper, __assign({
    variant: variant,
    as: renderAs
  }, props), props.children);
};

export default Typography;